<template>
  <form autocomplete="off">
    <div class="w-full m-0">
      <div class="example">
        <span
          v-if="this.executiveData.length >= 2000  && toggle == false"
          v-html="$options.filters.limitTo(this.executiveData)"
        ></span>
        <vs-button
          color="success"
          type="filled"
          @click="toggleFlag()"
          v-show="this.executiveData.length >= 2000  && toggle == false"
          class="mt-2 btn-color"
        >{{ $t("labels.read_more") }}</vs-button>
        <span
          v-if="(this.executiveData.length < 2000  || toggle == true)"
          v-html="this.executiveData"
        ></span>
        <vs-button
          color="success"
          type="filled"
          @click="toggleFlag()"
          v-show="this.executiveData.length >= 2000  && toggle == true"
          class="mt-2 btn-color"
        >{{ $t("labels.read_less") }}</vs-button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  props: ["executiveData", "projectId", "consultantId", "serviceId"],
  data() {
    return {
      toggle: false,
      content: this.executiveData
    };
  },
  methods: {
    toggleFlag: function() {
      this.toggle = !this.toggle;
    }
  },
  filters: {
    limitTo: function(value) {
      if (!value) return "";
      return value.substring(0, 2000) + "...";
    }
  }
};
</script>